module.exports = __webpack_public_path__ + "img/luck.de89f904.png";